import { getRecordList, getMediaUrl } from '@src/utils/media-data';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { getOmniData, Ids } from '@src/services/omni-api';
import copyToClipboard from 'copy-to-clipboard';
import Toast from '@src/components/toast';

class Part1Store extends BaseStore {
  @observable activityData = [];
  // activityData = [
  //   {
  //     tabImg: require('./images/tab-img1.png'),
  //     activeTabImg: require('./images/tab-img1-active.png'),
  //     activityImg: require('./images/activity-img1.png'),
  //     isActivities: 0
  //   },
  //   {
  //     tabImg: require('./images/tab-img2.png'),
  //     activeTabImg: require('./images/tab-img2-active.png'),
  //     activityImg: require('./images/activity-img1.png'),
  //     isActivities: 1
  //   },
  //   {
  //     tabImg: require('./images/tab-img3.png'),
  //     activeTabImg: require('./images/tab-img3-active.png'),
  //     activityImg: require('./images/activity-img1.png'),
  //     isActivities: 0
  //   },
  //   {
  //     tabImg: require('./images/tab-img4.png'),
  //     activeTabImg: require('./images/tab-img4-active.png'),
  //     activityImg: require('./images/activity-img1.png'),
  //     isActivities: 0
  //   }
  // ];

  onChangeActivityIndex = index => {
    this.activitySwiperStore.activeIndex = index;
  };

  // 公测活动swiper
  activitySwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        slideChangeTransitionEnd: () => {
          this.onChangeActivityIndex(this.activitySwiperStore.activeIndex);
        },
        click: (event) => {
          if (event?.target?.dataset?.id === 'exchangeBtn' && event.target.dataset.exchangeCode) {
            this.onCopy(event.target.dataset.exchangeCode)
          }
        }
      }
    }
  });
  // 获取公测活动信息
  getActivityInfo = async () => {
    try {
      const res = await getOmniData(Ids.activity.channel, [{ dataSourceId: Ids.activity.dataSources.ds_id || '' }]);
      const items = getRecordList(res?.[Ids.activity.dataSources.ds_id]?.result?.items);
      // 因需求方数据未配置，暂时使用mock数据
      console.log('activity', items);
      this.activityData = items.map(item => ({
        activityImg: getMediaUrl(item.cover_img),
        tabImg: getMediaUrl(item.unchecked_title),
        activeTabImg: getMediaUrl(item.checked_title),
        // 是否可兑换
        isActivities: Number(item.is_activities) || 0,
        // 兑换码
        code: item.code || '',

        // 活动标题
        desc: getMediaUrl(item.desc),
        // 活动副标题
        activitySubtitle: getMediaUrl(item.activity_subtitle)
      }));
    } catch (error) {
      console.log(error);
    }
  };
  /** 复制 */
  onCopy = text => {
    const success = copyToClipboard(text);
    success ? Toast.success('复制成功') : Toast.fail('复制失败');
  };

  use() {
    super.use();
    useMount(() => {
      this.getActivityInfo();
    });
  }
}

export default Part1Store;
